"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var client_exports = {};
__export(client_exports, {
  createFileStorage: () => createFileStorage
});
module.exports = __toCommonJS(client_exports);
var import_datalake = require("./datalake");
var import_front = require("./front");
var import_teronlake = require("./teronlake");
function createFileStorage(config) {
  const { uploadUrl, datalakeUrl, teronlakeUrl } = config;
  if (datalakeUrl !== void 0 && datalakeUrl !== "") {
    console.debug("Using Datalake storage");
    return new import_datalake.DatalakeStorage(datalakeUrl);
  }
  if (teronlakeUrl !== void 0 && teronlakeUrl !== "") {
    console.debug("Using Teronlake storage");
    return new import_teronlake.TeronlakeStorage(teronlakeUrl);
  }
  console.debug("Using Front storage");
  return new import_front.FrontStorage(uploadUrl);
}
__name(createFileStorage, "createFileStorage");
//# sourceMappingURL=index.js.map
